import React from 'react';
import { motion } from 'framer-motion';
import { LayersIcon, UtensilsIcon, ClockIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full bg-[#FAFAF7] text-[#111111] py-24 px-4 sm:px-6" data-id="element-78">
      <div className="max-w-5xl mx-auto" data-id="element-79">
        <div className="text-center mb-16" data-id="element-80">
          <span className="text-[#E8652D] font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-81">
            El Secreto
          </span>
          <h2 className="text-3xl sm:text-5xl font-bold mb-6" data-id="element-82">
            El mecanismo: <br className="sm:hidden" data-id="element-83" />3 Bases + 5 Variaciones
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-84">
            Misma compra. Misma cocción. Pero se siente como comidas diferentes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20" data-id="element-85">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100" data-id="element-86">
            <div className="flex items-start gap-4 mb-6" data-id="element-87">
              <div className="bg-blue-100 p-3 rounded-lg text-blue-600" data-id="element-88">
                <LayersIcon className="h-8 w-8" data-id="element-89" />
              </div>
              <div data-id="element-90">
                <h3 className="text-xl font-bold mb-2" data-id="element-91">3 Bases</h3>
                <p className="text-gray-600" data-id="element-92">
                  Tus proteínas ancla de la semana. Se cocinan de una sola vez,
                  sin complicaciones.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-93">
              <div className="bg-[#E8652D]/10 p-3 rounded-lg text-[#E8652D]" data-id="element-94">
                <UtensilsIcon className="h-8 w-8" data-id="element-95" />
              </div>
              <div data-id="element-96">
                <h3 className="text-xl font-bold mb-2" data-id="element-97">5 Variaciones</h3>
                <p className="text-gray-600" data-id="element-98">
                  Sabores y estilos para no aburrirte. Cambia la salsa, el
                  acompañamiento o la presentación.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-99">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-100">
              Y lo mejor: está diseñado para{' '}
              <span className="font-bold bg-[#E8652D]/10 px-1 rounded" data-id="element-101">
                airfryer + cocina
              </span>
              , porque es lo que la mayoría realmente usa.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-102">
              Olvídate de ensuciar mil ollas o prender el horno por 3 horas.
              Esto es cocina de guerrilla para gente ocupada.
            </p>
          </motion.div>
        </div>

        {/* Daily Life Example */}
        <div className="bg-[#111111] text-[#FAFAF7] rounded-3xl p-8 sm:p-12 overflow-hidden relative" data-id="element-103">
          <div className="absolute top-0 right-0 p-32 bg-[#E8652D] opacity-5 blur-[100px] rounded-full pointer-events-none" data-id="element-104"></div>

          <h3 className="text-2xl font-bold mb-10 text-center relative z-10" data-id="element-105">
            Cómo se ve en tu vida (ejemplo real)
          </h3>

          <div className="grid sm:grid-cols-2 gap-8 relative z-10" data-id="element-106">
            <div className="border-l-2 border-[#E8652D] pl-6" data-id="element-107">
              <h4 className="text-[#E8652D] font-bold text-lg mb-4 uppercase tracking-wide" data-id="element-108">
                Domingo
              </h4>
              <ul className="space-y-4" data-id="element-109">
                <li className="flex items-center gap-3" data-id="element-110">
                  <ClockIcon className="h-5 w-5 text-gray-400" data-id="element-111" />
                  <span data-id="element-112">10 minutos planificando</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-113">
                  <ClockIcon className="h-5 w-5 text-gray-400" data-id="element-114" />
                  <span data-id="element-115">60–90 min de prep mínimo viable</span>
                </li>
              </ul>
            </div>

            <div className="border-l-2 border-gray-700 pl-6" data-id="element-116">
              <h4 className="text-white font-bold text-lg mb-4 uppercase tracking-wide" data-id="element-117">
                Lunes a Viernes
              </h4>
              <ul className="space-y-4" data-id="element-118">
                <li className="flex items-center gap-3" data-id="element-119">
                  <CheckIcon className="h-5 w-5 text-green-500" data-id="element-120" />
                  <span data-id="element-121">Abres el refri</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-122">
                  <CheckIcon className="h-5 w-5 text-green-500" data-id="element-123" />
                  <span data-id="element-124">Combinas Base + Variación</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-125">
                  <CheckIcon className="h-5 w-5 text-green-500" data-id="element-126" />
                  <span data-id="element-127">Comes en 3–5 minutos</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 text-center pt-8 border-t border-white/10" data-id="element-128">
            <p className="text-xl font-medium" data-id="element-129">
              Sin pensar. Sin negociar contigo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
function CheckIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-130">
      <polyline points="20 6 9 17 4 12" data-id="element-131" />
    </svg>;
}